import { EnvironmentState, ThemeColor } from "./environment.types"

const state = (): EnvironmentState => ({
  webview: false,
  languages: [],
  theme: {
    color: null,
    defaultColor: ThemeColor.Light
  },
  header: {
    items: []
  },
  footer: {
    currentYear: {
      value: String(new Date().getFullYear())
    },
    columns: []
  },
  subscribeDialog: {
    image: {
      src: '',
      alt: ''
    }
  }
})

export default state
